import React from "react";
import BreadCrumb from "../bread-crumb/bread-crumb";
import "./form-header.scss";

interface BreadCrumbSlot {
  link: string;
  label: string | JSX.Element;
  linkState?: any;
}

interface FormHeaderProps {
  breadCrumbPath: BreadCrumbSlot[];
  children?: React.ReactNode;
  containerProps?:any;
}
const FormHeader = (props: FormHeaderProps) => {
  const { breadCrumbPath, children, containerProps } = props;
  return (
    <div className="formHeader--Header" {...containerProps}>
      <BreadCrumb path={breadCrumbPath} />
      <div>{children}</div>
    </div>
  );
};

export { FormHeader };
export default FormHeader;
